import { Link } from "react-router-dom";
import { getCategory, type Article } from "@/mocks/content";

interface Props {
  article: Article;
  horizontal?: boolean;
}

export default function ArticleCard({ article, horizontal = false }: Props) {
  const cat = getCategory(article.category);

  if (horizontal) {
    return (
      <Link
        to={`/article/${article.slug}`}
        className="group flex flex-col gap-4 rounded-xl bg-background-50 p-4 transition-colors hover:bg-background-100 sm:flex-row sm:gap-5"
      >
        <div className="h-44 w-full shrink-0 overflow-hidden rounded-lg sm:h-32 sm:w-44">
          <img
            src={article.cover}
            alt={`${article.title} 配图`}
            className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
        </div>
        <div className="flex flex-col justify-center">
          <div className="flex items-center gap-2">
            <span className={`rounded-full px-2.5 py-0.5 text-xs font-medium ${cat.chip}`}>
              {cat.name}
            </span>
            <span className="text-xs text-foreground-500">
              {article.author} · {article.date}
            </span>
          </div>
          <h3 className="mt-2 font-display text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-600">
            {article.title}
          </h3>
          <p className="mt-1.5 line-clamp-2 text-sm text-foreground-600">{article.summary}</p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${article.slug}`}
      className="group flex flex-col overflow-hidden rounded-xl bg-background-50 ring-1 ring-background-200/70 transition-all hover:-translate-y-1 hover:ring-primary-300"
    >
      <div className="relative h-44 w-full overflow-hidden">
        <img
          src={article.cover}
          alt={`${article.title} 配图`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-3 top-3 flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium text-background-50 ${cat.dot}`}
        >
          <i className="ri-flashlight-line" aria-hidden="true" />
          {article.status}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-5">
        <p className="text-xs font-medium tracking-wide text-primary-600">{cat.en}</p>
        <h3 className="mt-2 font-display text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-600">
          {article.title}
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
          {article.summary}
        </p>
        <div className="mt-4 flex items-center justify-between border-t border-background-200/70 pt-3 text-xs text-foreground-500">
          <span>{article.date}</span>
          <span className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line" aria-hidden="true" />
              {(article.views / 10000).toFixed(article.views >= 100000 ? 1 : 0)}w
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line" aria-hidden="true" />
              {article.readMin} 分钟
            </span>
          </span>
        </div>
      </div>
    </Link>
  );
}